export const PALETA_ATENDENTES = {
  coral: {
    nome: 'Coral',
    claro: { texto: '#C2412D', fundo: '#FCE9E4' },
    escuro: { texto: '#FF8A73', fundo: '#3A1F1A' },
  },
  violeta: {
    nome: 'Violeta',
    claro: { texto: '#7A3FD1', fundo: '#EFE6FC' },
    escuro: { texto: '#B897FF', fundo: '#2A1F42' },
  },
  rosa: {
    nome: 'Rosa',
    claro: { texto: '#B8326E', fundo: '#FBE5EF' },
    escuro: { texto: '#FF85B8', fundo: '#3A1A29' },
  },
  oliva: {
    nome: 'Oliva',
    claro: { texto: '#5B7A12', fundo: '#EDF3DC' },
    escuro: { texto: '#B5D86A', fundo: '#26301A' },
  },
  vinho: {
    nome: 'Vinho',
    claro: { texto: '#8E2443', fundo: '#F6E3E8' },
    escuro: { texto: '#E87A99', fundo: '#36161F' },
  },
  indigo: {
    nome: 'Índigo',
    claro: { texto: '#3F45B8', fundo: '#E5E6FA' },
    escuro: { texto: '#9EA3FF', fundo: '#1F2142' },
  },
  ferrugem: {
    nome: 'Ferrugem',
    claro: { texto: '#9A4A12', fundo: '#F6E9DD' },
    escuro: { texto: '#E5A06A', fundo: '#33231A' },
  },
  ciano: {
    nome: 'Ciano',
    claro: { texto: '#0B6E99', fundo: '#DFF0F8' },
    escuro: { texto: '#6CC6EE', fundo: '#132A36' },
  },
  magenta: {
    nome: 'Magenta',
    claro: { texto: '#A12BA8', fundo: '#F7E4F8' },
    escuro: { texto: '#EB8AF0', fundo: '#371A39' },
  },
  grafite: {
    nome: 'Grafite',
    claro: { texto: '#3D4656', fundo: '#E7EAF0' },
    escuro: { texto: '#C3CAD8', fundo: '#262C38' },
  },
} as const;

export type CorAtendente = keyof typeof PALETA_ATENDENTES;
export const CORES_ATENDENTE = Object.keys(PALETA_ATENDENTES) as CorAtendente[];

export function proximaCorLivre(emUso: readonly string[]): CorAtendente {
  return (
    CORES_ATENDENTE.find((c) => !emUso.includes(c)) ??
    CORES_ATENDENTE[emUso.length % CORES_ATENDENTE.length]!
  );
}
